var _g, _g2, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 102,
  height: 110,
  fill: "none",
  viewBox: "0 0 102 110"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#map-marker_svg__a)",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M83 77.926c0 5.757-25.6 12.953-32 12.953s-32-7.196-32-12.953c0-3.974 14.327-7.195 32-7.195s32 3.221 32 7.195"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-figma-bg-blur-radius": 56.889
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M83 32.457C83 58.423 57.4 90.88 51 90.88S19 58.423 19 32.457C19 14.532 33.327 0 51 0s32 14.532 32 32.457"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#map-marker_svg__b)",
  strokeOpacity: 0.5,
  strokeWidth: 1.185,
  d: "M51 .593c17.338 0 31.407 14.258 31.407 31.864 0 12.817-6.33 27.308-13.508 38.632-3.582 5.653-7.36 10.489-10.627 13.904-1.636 1.709-3.132 3.05-4.404 3.96-.636.454-1.205.793-1.698 1.017-.499.226-.887.317-1.17.317s-.671-.091-1.17-.317c-.493-.224-1.062-.563-1.698-1.018-1.272-.91-2.768-2.25-4.404-3.959-3.268-3.415-7.044-8.251-10.627-13.904-7.177-11.324-13.508-25.815-13.508-38.632C19.593 14.851 33.663.593 51 .593Z"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 47.407,
  height: 46.948,
  x: 27.296,
  y: 8.219,
  fill: "#4951EF",
  rx: 23.474
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 48.593,
  height: 48.133,
  x: 26.704,
  y: 7.626,
  stroke: "url(#map-marker_svg__c)",
  strokeOpacity: 0.2,
  strokeWidth: 1.185,
  rx: 24.067
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "map-marker_svg__b",
  x1: 51,
  x2: 51,
  y1: 0,
  y2: 90.88,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.471,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A1A1A1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "map-marker_svg__c",
  x1: 51,
  x2: 51,
  y1: 8.219,
  y2: 55.167,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A1A1A1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.529,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("filter", {
  id: "map-marker_svg__a",
  width: 101.926,
  height: 58.074,
  x: 0.037,
  y: 51.767,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_41029_4730",
  stdDeviation: 9.481
})))));
export { SvgMapMarker as ReactComponent };